import { useState } from "react";

const WHATSAPP_NUMBER = "919338000045"; // Replace with actual number (country code + number, no +)
const WHATSAPP_MESSAGE = "Hello! I'm interested in your immigration services.";

const WhatsAppFloat = () => {
  const [hovered, setHovered] = useState(false);

  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: "fixed",
          bottom: "28px",
          right: "28px",
          zIndex: 99998,
          display: "flex",
          alignItems: "center",
          gap: "10px",
          textDecoration: "none",
        }}
      >
        {/* Tooltip label */}
        <span
          style={{
            background: "#fff",
            color: "#0f172a",
            fontSize: "13px",
            fontWeight: "600",
            padding: "7px 14px",
            borderRadius: "20px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.14)",
            whiteSpace: "nowrap",
            opacity: hovered ? 1 : 0,
            transform: hovered ? "translateX(0)" : "translateX(8px)",
            transition: "opacity 0.22s ease, transform 0.22s ease",
            pointerEvents: "none",
          }}
        >
          Chat with us
        </span>

        {/* WhatsApp button */}
        <div
          style={{
            width: "58px",
            height: "58px",
            borderRadius: "50%",
            background: "#25D366",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: hovered
              ? "0 8px 28px rgba(37,211,102,0.55)"
              : "0 4px 18px rgba(37,211,102,0.4)",
            transform: hovered ? "scale(1.1)" : "scale(1)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
            flexShrink: 0,
          }}
        >
          {/* Pulse ring */}
          <span
            style={{
              position: "absolute",
              width: "58px",
              height: "58px",
              borderRadius: "50%",
              background: "rgba(37,211,102,0.35)",
              animation: "waPulse 2s ease-out infinite",
            }}
          />
          {/* WhatsApp SVG icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 32 32"
            fill="#fff"
            style={{ position: "relative", zIndex: 1 }}
          >
            <path d="M16.003 2.667C8.636 2.667 2.667 8.636 2.667 16c0 2.37.636 4.687 1.845 6.72L2.667 29.333l6.82-1.789A13.26 13.26 0 0016.003 29.333C23.37 29.333 29.333 23.364 29.333 16S23.37 2.667 16.003 2.667zm0 24.267a11.02 11.02 0 01-5.613-1.537l-.403-.24-4.047 1.062 1.08-3.943-.263-.41A11.007 11.007 0 014.96 16c0-6.09 4.953-11.04 11.043-11.04S27.04 9.91 27.04 16s-4.947 11.04-11.037 11.04zm6.07-8.27c-.333-.167-1.97-.973-2.277-1.083-.307-.113-.53-.167-.753.167-.223.333-.863 1.083-1.06 1.307-.193.22-.39.247-.723.083-.333-.167-1.407-.52-2.68-1.653-.99-.883-1.66-1.973-1.853-2.307-.193-.333-.02-.513.147-.68.15-.147.333-.387.5-.58.167-.197.223-.333.333-.557.113-.223.057-.417-.027-.583-.083-.167-.753-1.813-1.033-2.483-.273-.653-.547-.563-.753-.573-.193-.01-.417-.013-.64-.013s-.583.083-.89.417c-.307.333-1.17 1.143-1.17 2.787s1.197 3.23 1.363 3.453c.167.223 2.357 3.597 5.71 5.047.797.343 1.42.547 1.903.7.8.253 1.527.217 2.103.133.643-.097 1.97-.807 2.247-1.587.277-.78.277-1.447.193-1.587-.08-.14-.303-.223-.637-.39z" />
          </svg>
        </div>
      </a>

      <style>{`
        @keyframes waPulse {
          0%   { transform: scale(1);   opacity: 0.7; }
          70%  { transform: scale(1.55); opacity: 0; }
          100% { transform: scale(1.55); opacity: 0; }
        }
      `}</style>
    </>
  );
};

export default WhatsAppFloat;
